/** Устанавлнивает признак инициализированности АПИ */
export const setIsInit = (status) => {
    //имя переменной isInited
    return {type: 'SET_API_INIT_STATUS', payload: status};
};
/**данные пользователя (авторизаци, возобновление) */
export const setUser = (user) => {
    return {type: 'SET_API_USER_DATA', payload: user};
};
/**Права пользователя*/
export const setRights = (rights) => {
    return {type: 'SET_API_USER_RIGHTS', payload: rights};
};
/**список доступных геообъектов */
export const setGeoObjs = (geoObjs) => {
    return {type: 'SET_API_GEO_OBJECTS', payload: geoObjs};
};
/**Отчет по одинокому геообъекту */
export const setGeoObjReport = (geoObjReport) => {
    return {type: 'SET_API_GEO_OBJECT_REPORT', payload: geoObjReport};
};
/**Отчет по группе геообъектов */
export const setMultiGeoObjReport = (geoMultiObjReport) => {
    return {type: 'SET_API_GEO_MULTI_OBJECT_REPORT', payload: geoMultiObjReport};
};
/**Дашборд по одинокому геообъекту */
export const setGeoObjDashboard = (geoObjDashboard) => {
    return {type: 'SET_API_GEO_OBJECT_DASHBOARD', payload: geoObjDashboard};
};
/**Маршрут геообъекта */
export const setGeoObjRoute = (geoObjRoute) => {
    return {type: 'SET_API_GEO_OBJECT_ROUTE', payload: geoObjRoute};
};
/**Геозоны */
export const setGeoObjGeozone = (geoObjGeozone) => {
    return {type: 'SET_API_GEO_OBJECT_GEOZONE', payload: geoObjGeozone};
};
/**Сохранение геозоны */
export const setSavingGeoObjGeozone = (savingGeoObjGeozone) => {
    return {type: 'SET_API_SAVING_GEO_OBJECT_GEOZONE', payload: savingGeoObjGeozone};
};
/**Пересечения трэкером геозоны */
export const setGeozoneIntersections = (geozoneIntersections) => {
    return {type: 'SET_API_SAVING_GEOZONE_INTERSECTIONS', payload: geozoneIntersections};
};
/**Распределение по геозонам вида активности трекера */
export const setActivitiByZone = (activitiByZone) => {
    return {type: 'SET_API_ACTIVITI_BY_ZONE', payload: activitiByZone};
};
/**Данные для отчета в формате Excel геообъекта */
export const setGeoObjReportExcel = (geoObjReportExcel) => {
    return {type: 'SET_API_GEO_OBJECT_REPORT_EXCEL', payload: geoObjReportExcel};
};
/**Данные о посещении геозон */
export const setObjVisits = (geoObjVisits) => {
    return {type: 'SET_API_GEO_OBJECT_VISITS', payload: geoObjVisits};
};
/**Данные для отчета в формате Excel по группе геообъектов */
export const setMultiGeoObjReportExcel = (geoMultiObjReportExcel) => {
    return {type: 'SET_API_GEO_MULTI_OBJECT_REPORT_EXCEL', payload: geoMultiObjReportExcel};
};
/**Загрузка табеля рабочего времени по группе геообъектов */
export const setWorkingTimeSheet = (workingTimeSheet) => {
    return {type: 'SET_API_WORKING_TIME_SHEET', payload: workingTimeSheet};
};
/**Список справочников */
export const setDirectoryList = (directoryList) => {
    return {type: 'SET_API_DIRECTORY_LIST', payload: directoryList};
};
/**Данные справочника */
export const setDirectoryData = (directoryData) => {
    return {type: 'SET_API_DIRECTORY_DATA', payload: directoryData};
};
/**Краткие данные справочника (для выпадающих списков)*/
export const setDirectoryShort = (directoryShort) => {
    return {type: 'SET_API_DIRECTORY_SHORT', payload: directoryShort};
};
/**Статус сохранения справочника*/
export const setSavingDirectory = (savingDirectory) => {
    return {type: 'SET_API_SAVING_DIRECTORY', payload: savingDirectory};
};
/**Статус добавления справочника*/
export const setAddingDirectory = (addingDirectory) => {
    return {type: 'SET_API_ADDING_DIRECTORY', payload: addingDirectory};
};
/**Статус удаления справочника*/
export const setDeletingDirectory = (deletingDirectory) => {
    return {type: 'SET_API_DELETING_DIRECTORY', payload: deletingDirectory};
};

/**Все документы выбранного вида*/
export const setDocumentData = (documentData) => {
    return {type: 'SET_API_DOCUMENT_DATA', payload: documentData};
};
/**Один документ выбранного типа*/
export const setSingleDocument = (singleDocument) => {
    return {type: 'SET_API_SINGLE_DOCUMENT', payload: singleDocument};
};
/**Один документ выбранного типа (отдельная загрузка)*/
export const setSingleDocument2 = (singleDocument2) => {
    return {type: 'SET_API_SINGLE_DOCUMENT2', payload: singleDocument2};
};
/**Статус добавления док-та*/
export const setAddingDocument = (addingDocument) => {
    return {type: 'SET_API_ADDING_DOCUMENT', payload: addingDocument};
};
/**Статус сохранения док-та*/
export const setSavingDocument = (savingDocument) => {
    return {type: 'SET_API_SAVING_DOCUMENT', payload: savingDocument};
};
/**Статус удаления док-та*/
export const setDeletingDocument = (deletingDocument) => {
    return {type: 'SET_API_DELETING_DOCUMENT', payload: deletingDocument};
};
/**Статус изменения статуса док-та*/
export const setChangeStatusDocument = (changingStatusDocument) => {
    return {type: 'SET_API_CHANGING_STATUS_DOCUMENT', payload: changingStatusDocument};
};
/**Вымышленный справочник работ в ПГ*/
export const setPlanWorkDir = (planWorkDir) => {
    return {type: 'SET_API_PLAN_WORK_DIR', payload: planWorkDir};
};
/**Возможные статусы ПГ*/
export const setPlanScheduleStatuses = (planScheduleStatuses) => {
    return {type: 'SET_API_PLAN_SHEDULE_STATUSES', payload: planScheduleStatuses};
};
/**Возможные статусы ЗН*/
export const setOrderWorkStatuses = (orderWorkStatuses) => {
    return {type: 'SET_API_ORDER_WORK_STATUSES', payload: orderWorkStatuses};
};
/**Информация для нижней панельки*/
export const setFooterInfo = (footerInfo) => {
    return {type: 'SET_API_FOOTER_INFO', payload: footerInfo};
};

/** Детали по тревогам **/
export const setAlarmsInfo = (alarmsInfo) => {
    return {type: 'SET_API_ALARMS_INFO', payload: alarmsInfo};
};
